module.exports = __webpack_public_path__ + "img/anis_1323.3fa14bb6.jpg";